/* global __SERVER__ */

import React, { PropTypes, PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';

import { fetchEvents } from '../../state/actions';
import apiService from '../../state/services/api';
import { formatNumber } from '../../utils/formats';
import { trackPageVisit } from '../../utils/tracking';
import getDataFromProps from './helpers/getDataFromProps';

import Container from '../Container';
import DiscoveryPage from './component';

/**
 * Discovery Page container component.
 */
class DiscoveryPageContainer extends PureComponent {
  state = {
    countryCode: undefined,
    data: getDataFromProps(this.props),
    savedCount: undefined,
    topTips: undefined,
    upcomingCount: undefined,
  };

  componentWillMount() {
    const { route } = this.props;
    if (!this.state.data) {
      route.status = 404;
    }
  }

  async componentDidMount() {
    this.fetchData();
    this.trackVisit();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState(
        {
          data: getDataFromProps(nextProps),
          savedCount: undefined,
          upcomingCount: undefined,
          topTips: undefined,
        },
        async () => {
          this.fetchData();
          this.trackVisit();
        },
      );
    }
  }

  fetchData = () => {
    if (this.state.data) {
      apiService.fetchEvents(this.state.data.query).then((response) => {
        this.setState({ upcomingCount: response.total });
      });
      if (this.state.data.query.sport) {
        apiService.getSavedSearches().then((saves) => {
          const { sport, sportDistance } = this.state.data.query;
          const sportIdDistanceId = sportDistance ? `${sport}-${sportDistance}` : sport.toString();
          // Find this sport/distance in all saved searches
          const savedSearch = saves.filter(
            search => search.sportIdDistanceId === sportIdDistanceId,
          )[0];
          if (savedSearch) {
            this.setState({ savedCount: savedSearch.total });
          }
        });
        apiService.fetchReviews('', {
          staffPick: 'topTips',
          sport: this.state.data.query.sport,
          distance: this.state.data.query.sportDistance,
        })
        .then((topTips) => {
          if (topTips.length) {
            this.setState({ topTips });
          }
        })
        .catch(() => {
          // Do nothing
        });
      }
    }
  };

  trackVisit = () => {
    if (this.state.data) {
      trackPageVisit(`${this.state.data.label} Events`);
    }
  };

  render() {
    if (this.state.data) {
      const savedCount = this.state.savedCount && formatNumber(this.state.savedCount);
      const upcomingCount = this.state.upcomingCount && formatNumber(this.state.upcomingCount);
      const topTips = this.state.topTips;
      const { localeSlug } = this.props.params;

      return (
        <DiscoveryPage
          {...this.state.data}
          localeSlug={localeSlug}
          savedCount={savedCount}
          topTips={topTips}
          upcomingCount={upcomingCount}
        />
      );
    }

    return (
      <Container>
        <h2>{'Sorry, we can’t find that page'}</h2>
      </Container>
    );
  }
}

DiscoveryPageContainer.propTypes = {
  location: PropTypes.shape().isRequired,
  params: PropTypes.shape().isRequired,
  route: PropTypes.shape().isRequired,
  localeSlug: PropTypes.string,
};

DiscoveryPageContainer.defaultProps = {
  localeSlug: undefined,
};

const mapStateToProps = state => ({
  locations: state.locations,
  countryCode: state.countryCode,
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const DiscoveryPageContainerWithRedux = connect(mapStateToProps)(DiscoveryPageContainer);

// Configure promises that must be fulfilled before the component is rendered, e.g. fetch event data
export const asyncPromises = [
  {
    promise: ({ location, params, store: { dispatch, getState } }) => {
      const { locations, countryCode } = getState();
      const data = getDataFromProps({ location, locations, params, countryCode });
      if (data && data.lists) {
        const action = Promise.all(data.lists.map(list => dispatch(fetchEvents(list.query))));
        return __SERVER__ ? action : Promise.resolve();
      }
      return Promise.resolve();
    },
  },
];

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
const DiscoveryPageWithAsync = asyncConnect(asyncPromises)(DiscoveryPageContainerWithRedux);

export default DiscoveryPageWithAsync;



// WEBPACK FOOTER //
// ./app/src/components/Discovery/container.jsx